import { z } from 'zod/v4';

export const GetCompanyProfileParamsSchema = z.object({
  templateId: z.string().min(1),
  forCompanyId: z.string().min(1),
});

export type GetCompanyProfileParams = z.infer<
  typeof GetCompanyProfileParamsSchema
>;

// Loose: `data` is a dynamic-keyed bag of data-point answers and the row may
// carry extra audit-meta fields (createdAt, updatedByUserId, ...) — mirrors
// the legacy schema's `additionalProperties: true`.
export const CompanyProfileResponseSchema = z
  .object({
    forCompanyId: z.string(),
    byCompanyId: z.string(),
    onBehalfOfCompanyId: z.string(),
    profileType: z.string(),
    data: z.record(z.string(), z.unknown()),
    isConnected: z.boolean().optional(),
    isReverseConnected: z.boolean().optional(),
    templateCompletionPercentage: z.number().optional(),
  })
  .loose();

export type CompanyProfileResponse = z.infer<
  typeof CompanyProfileResponseSchema
>;
